<template>
    <Tag
        text="AI SWEDEN PARTNER"
        :classes="'bg-gray-50 border-gray-300'"
        :small="small"
    />
</template>

<script>
import Tag from '@/Components/Elements/Tags/Tag.vue'
export default {
    name: 'PartnerTag',

    components: {
        Tag,
    },

    props: {
        small: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
